export default __webpack_public_path__ + "static/media/csharp.fc0548b9.png";